<template>
  <div class="basic-setting-content pl16 pr16">
    <el-form ref="form" label-width="180px" size="small">
      <!--状态信息-->
      <div class="common-form">状态信息</div>
      <el-form-item label="时间：">
        <el-input v-model="status.time" class="max-w460" :disabled="true">
        </el-input>
      </el-form-item>
      <el-form-item label="实时重量：">
        <el-input v-model="status.weight" class="max-w460" :disabled="true">
        </el-input>
      </el-form-item>
      <el-form-item label="DTU信号强度：">
        <el-input v-model="status.rssi" class="max-w460" :disabled="true">
        </el-input>
      </el-form-item>
      <el-form-item label="是否超载：">
        <el-input v-model="status.overloadState" class="max-w460" :disabled="true">
        </el-input>
      </el-form-item>
      <el-form-item label="是否稳定：">
        <el-input v-model="status.stableState" class="max-w460" :disabled="true">
        </el-input>
      </el-form-item>
      <el-form-item label="内码值：">
        <el-input v-model="status.ADC" class="max-w460" :disabled="true">
        </el-input>
      </el-form-item>
      <el-form-item label="ADF在线状态：">
        <el-input v-model="status.ADFStatus" class="max-w460" :disabled="true">
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {getWebsocket} from '@/utils/websocket/GlobalWebSocket.js';

export default {
  components: {},
  data() {
    return {
      propertyStatus: {},
      status: {},
    };
  },
  props: ['scene'],
  inject: ['form'],
  created() {
    /*初始化*/
    this.init();
  },
  methods: {
    /*初始化*/
    init() {
      let self = this;
      // self.propertyStatus && self.propertyStatus.unsubscribe();
      let groupId = '$WB_SENSOR'
      self.propertyStatus = getWebsocket(
        `location-info-message-property-${self.form.model.deviceId}`,
        `/device/${self.form.model.productId}/${self.form.model.deviceId}/${groupId}/message/property/report`,
      ).subscribe((resp) => {
        const {payload} = resp;
        // weight = payload.value.weight;
        if (resp.requestId === `location-info-message-property-${self.form.model.deviceId}`) {
          self.$set(this.status, 'weight', payload.value.weight);
          self.$set(this.status, 'time', payload.value.time);
          self.$set(this.status, 'rssi', payload.value.rssi);
          self.$set(this.status, 'overloadState', payload.value.overloadState);
          self.$set(this.status, 'stableState', payload.value.stableState);
          self.$set(this.status, 'ADC', payload.value.ADC);
          self.$set(this.status, 'ADFStatus', payload.value.ADFStatus);
        }
      });
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Status.vue